export const ThemePicker =  {
    changeTheme (themeName) {
        let theme = Themes[themeName] ? Themes[themeName] : Themes['DiSupport'];
        for(let colorName in theme) {
            this.updateVariable(colorName, theme[colorName]);
        }
    },
    updateVariable (variableName, variableValue) {
        document.documentElement.style.setProperty(`--color-${variableName}`, `${variableValue}`);
    }
};

const DiSupport = {
    'primary': '#729FCC',
    'primary-active': '#466E96',
    'secondary': '#eeeeee',
    'darker-secondary': '#dedede',
    'dark': '#6b6b6b',
    'text-color-light': '#ffffff',
    'text-color-dark': '#000000',
    'background-color-light': '#ffffff',
    'background-color-dark': '#000000',
    'sidebar-logo-bg': '#5d8fc2',
    'sidebar-bg': '#729FCC',
    'sidebar-link-active': '#466E96',
    'sidebar-link-border': '#8db1d6'
};

const Rossmann = {
    'primary': '#d00132',
    'primary-active': '#9C0125',
    'secondary': '#eeeeee',
    'darker-secondary': '#dedede',
    'dark': '#6b6b6b',
    'text-color-light': '#ffffff',
    'text-color-dark': '#000000',
    'background-color-light': '#ffffff',
    'background-color-dark': '#000000',
    'sidebar-logo-bg': '#d00132',
    'sidebar-bg': '#d00132',
    'sidebar-link-active': '#9C0125',
    'sidebar-link-border': '#9C0125',
    'container-bg': '#eeeeee'
};


const Themes = {
    DiSupport,
    Rossmann
};

